import { render, staticRenderFns } from "./goolereviewcopt.vue?vue&type=template&id=0a3586c4&scoped=true&"
import script from "./goolereviewcopt.vue?vue&type=script&lang=js&"
export * from "./goolereviewcopt.vue?vue&type=script&lang=js&"
import style0 from "./goolereviewcopt.vue?vue&type=style&index=0&id=0a3586c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3586c4",
  null
  
)

export default component.exports